import React from 'react';

import PropTypes from 'prop-types';
import { RadioGroup } from '@telus-uds/components-web';

import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const DefectWebform = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const locale = useLocaleContext();
  const {
    reportIssue: {
      form: {
        labelDefectWebform,
        labelDefectWebformOptionBusinessConnect,
        labelDefectWebformOptionWirelineSecurity,
        labelDefectWebformOptionWireless,
        labelDefectWebformOptionPhoneNumberCheck,
        labelDefectWebformOptionContactCentre,
        labelDefectWebformOptionReferralTool,
        labelDefectWebformOptionInternetOfThings,
        labelDefectWebformOptionBusinessApps,
        labelDefectWebformOptionFullyManaged
      }
    }
  } = locale === 'en-US' ? EN : FR;

  const fieldError = 'defectWebform' in formErrors;
  const fieldOptions = [
    labelDefectWebformOptionBusinessConnect,
    labelDefectWebformOptionWirelineSecurity,
    labelDefectWebformOptionWireless,
    labelDefectWebformOptionPhoneNumberCheck,
    labelDefectWebformOptionContactCentre,
    labelDefectWebformOptionReferralTool,
    labelDefectWebformOptionInternetOfThings,
    labelDefectWebformOptionBusinessApps,
    labelDefectWebformOptionFullyManaged
  ];

  // Convert options to RadioGroup items format: { label, id }
  const items = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  const handleSelect = (value) => {
    if (value) {
      setFormErrors(previousValue => {
        const updatedValues = { ...previousValue };
        delete updatedValues.defectWebform;
        return updatedValues;
      });
      setFieldData(previousValue => ({
        ...previousValue,
        defectWebform: value
      }));
    }
  };

  return (
    <div>
      <RadioGroup
        legend={`${labelDefectWebform} *`}
        items={items}
        checkedId={fieldData.defectWebform || null}
        onChange={handleSelect}
        name="defectWebform"
        validation={fieldError ? 'error' : undefined}
        feedback={fieldError ? formErrors.defectWebform.message : undefined}
      />
    </div>
  );
};

DefectWebform.propTypes = {
  formErrors: PropTypes.shape({
    defectWebform: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectWebform;
